<template>
  <div class="timeuntil">
    <div class="event">Days Since {{ event }}</div>
    <div class="since">{{ daysSince }}</div>
    <br>
  </div>
</template>

<script>
  import { formatDistanceStrict } from "date-fns"
  export default {
    name: 'TimeSince',
    props: {
      event: String,
      year: Number,
      month: Number,
      day: Number
    },
    data() {
      return {
        timerCount: 30,
        daysSince: formatDistanceStrict(
          new Date(this.year, this.month-1, this.day, 0, 0),
          new Date(),
          { unit: "day"}
        )
      }
    },
    watch: {
      timerCount: {
        handler(value) {
          if (value > 0) {
            setTimeout(() => {
              this.timerCount--;
            }, 1000);
          }
        },
        immediate: true
      }
    }
  }
</script>

<style>
.event {

}
</style>